import React from "react";
import LoginPage from "./Pages/Login";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
//import "leaflet-control-geocoder/dist/Control.Geocoder.js";
import "leaflet-control-geocoder/dist/Control.Geocoder.css";
import CustomerDashboard from "./Pages/CustomerDashboard";
import AdminPage from "./Pages/AdminPage";
import AdminRoutes from "./auth/AdminRoutes";
import NotFound from "./Pages/NotFound";
import Widgets from "./components/Admin/Widgets";

const App = () => {
  return (
    <Router>
      <Routes>
          <Route path="/" element={<LoginPage />} />

          <Route path="/Admin" element={<AdminPage />} />
          <Route path="/Dashboard/:apiKey" element={<CustomerDashboard />} />

          <Route element={<AdminRoutes />}>
            <Route path="/Widgets" element={<Widgets />} />
          </Route>

          <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
    
  );
};

export default App;